import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    Edit, InfoOutlined,
} from '@material-ui/icons';
import {
    Typography, Grid, Avatar, IconButton,
} from '@material-ui/core';
import './EmployeeSelectionSummary.scss';
import ChipCompletedStep from '@commonClient2/components/ChipCompletedStep';
import { UPDATE_DRAFT_BID_PROFILE_OBJECTS } from '../../../store/bidProfileDraft';
import { UPDATE_BID_PROFILE_OBJECTS } from '../../../store/bidProfile';
import { BidProfileEditTab, UkgDateFormat } from '../../../../Enums';
import DateFormatService from '../../../../services/DateFormatService';
import { ManagerWarning } from '../../../../components';
import { isShowEmployeeSelectionWarning } from '../../EmployeeSelection/EmployeeSelection';

function EmployeeSelectionSummary() {
    /** @type {ShiftBidding.ManagerStore} */
    // @ts-ignore
    const { bidProfileDraft, bidProfile, managerAppData } = useSelector((state) => state);
    const { t } = useTranslation('shiftBidding');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    /**
     * @type {BiddingDraft.IBidProfileDraft | BidProfile.IBidProfile | undefined}
     */
    let profile;
    let isDraft = false;
    let handleEdit = () => { };
    if (bidProfileDraft.id !== '') {
        profile = bidProfileDraft;
        isDraft = true;

        handleEdit = () => {
            dispatch({
                type: UPDATE_DRAFT_BID_PROFILE_OBJECTS,
                payload: {
                    general: {
                        tabSelected: BidProfileEditTab.Form,
                    },
                    bidProfileInformation: {
                        isExpanded: false,
                    },
                    scheduleTemplates: {
                        isExpanded: false,
                    },
                    employees: {
                        isExpanded: true,
                    },
                    schedule: {
                        isExpanded: false,
                    },
                },
            });
            navigate('/Manager/form');
        };
    } else if (bidProfile.id !== '') {
        profile = bidProfile;
        isDraft = false;

        handleEdit = () => {
            dispatch({
                type: UPDATE_BID_PROFILE_OBJECTS,
                payload: {
                    general: {
                        tabSelected: BidProfileEditTab.Form,
                    },
                    bidProfileInformation: {
                        isExpanded: false,
                    },
                    scheduleTemplates: {
                        isExpanded: false,
                    },
                    employees: {
                        isExpanded: true,
                    },
                    schedule: {
                        isExpanded: false,
                    },
                },
            });
            navigate('/Manager/form');
        };
    }

    if (profile === undefined) {
        return <></>;
    }

    const {
        originalEmployees,
        employees,
        managerWarnings,
        isCreationAllowed,
        isViewAllowed,
    } = profile;
    const selectedHyperfind = managerAppData.hyperfinds.find((x) => x.value === originalEmployees.hyperfindId);

    return (
        <div className="summary-section">
            <div className="summary-section-header">
                <div className="summary-section-avatar-title-wrapper">
                    <Avatar className="bde-avatar">3</Avatar>
                    <Typography variant="h6">{t('form.employeeSelectionSubHeader')}</Typography>
                </div>
                <Grid
                    item
                    className="summary-section-indicator-container"
                >
                    {isShowEmployeeSelectionWarning(profile) && (
                        <ManagerWarning
                            warnings={managerWarnings}
                            t={t}
                            isMini
                        />
                    )}
                    {isDraft ? (
                        <span
                            className="summary-completed-icon-wrapper"
                        >
                            {
                                originalEmployees.isCompleted && <ChipCompletedStep />
                            }
                        </span>
                    ) : null}
                    {(isCreationAllowed || isViewAllowed) && (
                        <IconButton
                            color="primary"
                            className="summary-edit-button"
                            onClick={() => handleEdit()}
                        >
                            {(employees.isEditable && isCreationAllowed) ? <Edit /> : <InfoOutlined />}
                        </IconButton>
                    )}
                </Grid>
            </div>

            <div className="summary-section-content">
                <div>
                    <Typography
                        variant="body1"
                        display="inline"
                    >
                        {t('form.hyperfind')}
                        {' '}
                        :
                    </Typography>
                    <Typography
                        variant="body2"
                        display="inline"
                    >
                        {' '}
                        {selectedHyperfind?.label}
                    </Typography>
                </div>
                <div>
                    <Typography
                        variant="body1"
                        display="inline"
                    >
                        {t('form.from')}
                        {' '}
                        :
                    </Typography>
                    <Typography
                        variant="body2"
                        display="inline"
                    >
                        {' '}
                        {DateFormatService.formatDateOrEmpty(originalEmployees.periodSelected.startDate, UkgDateFormat.LongDate)}
                    </Typography>
                </div>
                <div>
                    <Typography
                        variant="body1"
                        display="inline"
                    >
                        {t('form.to')}
                        {' '}
                        :
                    </Typography>
                    <Typography
                        variant="body2"
                        display="inline"
                    >
                        {' '}
                        {DateFormatService.formatDateOrEmpty(originalEmployees.periodSelected.endDate, UkgDateFormat.LongDate)}
                    </Typography>
                </div>
            </div>
        </div>
    );
}

export default EmployeeSelectionSummary;
